export function setLocalAuth(authToken: string) {
  localStorage.setItem('auth_token', authToken)
}

export function getLocalAuth() {
  return localStorage.getItem('auth_token')
}
